/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Search from '@mui/icons-material/Search';
import { useDispatch, useSelector } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { SearchResult } from './tableHeads';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

// export default function DispCurrentZeroURA() {
//   return (
//     <div>
//       <h1>Test</h1>
//     </div>
//   );
// }

export default function DispCurrentZeroURA() {
  const dispatch = useDispatch();
  const [searchResultList, setSearchResultList] = useState([]);

  const {
    rebateProgramValue,
    rebateProgramName,
    rebateProgramList,
    fromQuarter,
    toQuarter,
    isNDCChecked,
    manufacturer,
    manufacturerName,
    isLoading,
    currentZeroResult,
  } = useSelector((state) => state?.sharedState?.CurrentZeroURAReducer);

  // TO get the complete name of the rebate program
  const rebateProgramNameValue = rebateProgramName;
  //   rebateProgramList.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${rebateProgramNameValue?.rebateProgramCd} - ${
  //   rebateProgramNameValue?.shortDescr || ''
  // }`;

  const [fullScreenView, setfullScreenView] = useState(false);

  // To handle Full screen display
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };

  React.useEffect(() => {
    setSearchResultList(currentZeroResult);
  }, [currentZeroResult]);

  // PDF Header
  const firstInfo = `Quarter : ${fromQuarter} - ${
    toQuarter === '' ? fromQuarter : toQuarter
  }`;
  const secondInfo = isNDCChecked
    ? 'NDC not on CMS type : Included'
    : 'NDC not on CMS type : Excluded';
  const thirdInfo = `${rebateProgramNameValue}`;
  const fourthInfo = `Manufacturer : ${
    manufacturer === 'ALL' ? 'ALL' : manufacturerName
  }`;

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      {!fullScreenView && (
        <CustomSeparator
          parent1="Detail Reports"
          parent2="Display Current Zero URA"
        />
      )}

      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="mui-custom-form input-md field-xl">
              <div className="row mb-2">
                <div className="col-6">
                  <TextField
                    label="Rebate program : "
                    id="Rebate program :"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    value={rebateProgramNameValue}
                  />
                </div>
                <div className="col-6">
                  <div className="row">
                    <div className="col-5">
                      <TextField
                        label="Quarter Range : "
                        id="Quarter Range : "
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={fromQuarter}
                      />
                    </div>
                    <div style={{ paddingTop: '25px' }}>
                      <b>-</b>
                    </div>
                    <div className="col-5">
                      <TextField
                        fullWidth
                        label="QuarterRangeValue"
                        className="frr-display-hidden-label"
                        id="QuarterRangeValue"
                        placeholder=""
                        InputProps={{ id: 'QuarterRangeValue' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={toQuarter === '' ? fromQuarter : toQuarter}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-6 mt-3">
                  <TextField
                    label="Manufacturer : "
                    id="Manufacturer : "
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    value={manufacturer === 'ALL' ? 'ALL' : manufacturerName}
                  />
                </div>
                <div
                  className="col-5"
                  style={{ marginTop: '41px', marginLeft: '18px' }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isNDCChecked}
                        disabled
                        color="primary"
                        name="Include NDC's not on CMS tape"
                      />
                    }
                    label="Include NDC's not on CMS tape"
                  />
                </div>
              </div>
            </div>
          </>
        )}
        <div className="row" style={{ marginTop: 15 }}>
          <div className="unallocated" style={{ width: '100vw' }}>
            <TableGridWithFeatures
              columnDefs={SearchResult}
              rowData={
                searchResultList?.map((item) => {
                  return {
                    ...item,
                    units: item.units.toFixed(4),
                  };
                }) || []
              }
              noGlobalSort
              showSearchInfo
              rowMultiSelectWithClick
              enterMovesDown
              showResetFilter={false}
              handleViewHistory={false}
              hideTotalCount={false}
              exportFile
              fileName="CurrentZeroURA"
              reportName="Current Zero URA Report"
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
              isScrollOn
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
